// External packages
import { Navigate } from 'react-router-dom';

// Hooks
import { useUserRole } from 'components/ProtectedRoute';

export const RoleBasedRedirect = () => {
	const { isAdmin, isCashier } = useUserRole();

	if (isCashier) {
		return <Navigate to="/ulaznice" replace />;
	}

	if (isAdmin) {
		return <Navigate to="/eksponati" replace />;
	}

	// Default fallback - should not happen with proper authentication
	return <Navigate to="/eksponati" replace />;
};
